import React, { useEffect } from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

interface ProtectedRouteProps {
  element: React.ReactNode;
}

export const ProtectedRoute = ({ element }: ProtectedRouteProps) => {
  const { token, isTokenExpired, logout } = useAuth();

  const isInvalid = !token || isTokenExpired(token);

  useEffect(() => {
    if (isInvalid) {
      logout();
    }
  }, [isInvalid, logout]);

  if (isInvalid) {
    return <Navigate to="/login" replace />;
  }

  return <>{element}</>;
};